import styled from 'styled-components/macro'

export const SlashStyle = styled.span`
  font-size: inherit;
  color: ${(props) => props.theme.color.elementBgSecond};
`
